import type { MediaParams } from "@opensea/seadn"
import {
  AvatarBadge,
  Avatar as DSAvatar,
  type AvatarProps as DSAvatarProps,
} from "@opensea/ui-kit"
import type { Ref } from "react"
import { useRenderImage } from "../../providers/RenderImageProvider"

export type AvatarProps = DSAvatarProps &
  MediaParams & {
    ref?: Ref<HTMLDivElement | HTMLImageElement | HTMLVideoElement>
  }

export function AvatarBase({ ...props }: AvatarProps) {
  const { renderImage } = useRenderImage()
  return <DSAvatar renderImage={renderImage} {...props} />
}

// Create the composed Avatar with proper typing
const AvatarWithBadge = AvatarBase as typeof AvatarBase & {
  Badge: typeof AvatarBadge
}

AvatarWithBadge.Badge = AvatarBadge

export const Avatar = AvatarWithBadge
